import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Button as TopoloButton } from '@topolo-io/ui-kit';
const Button = React.forwardRef(({ variant = 'default', size = 'default', ...props }, ref) => (_jsx(TopoloButton, { ref: ref, variant: variant === 'default' ? 'primary' : variant, size: size === 'default' ? 'md' : size, ...props })));
Button.displayName = 'Button';
export { Button };
